import React, { useEffect } from 'react';
import { Spin } from 'antd';
import TaxMapsForm from './TaxMapsForm';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store';
import {
  usStateSelector,
  driversSelector,
  resultSelector,
  valueSelector,
} from './TaxMaps.selectors';
import { getState as getStateAction, searchTaxMaps } from './TaxMaps.actions';
import {
  USStateCodes,
  LocationFormNames,
  TAX_MAPS_FORM,
} from './TaxMaps.constants';
import { TaxMapResultTable } from './templates';
import { getFormValues } from 'redux-form';
import { LOADING, Sizes, loadingSelector, ReducerNames } from 'common';
import { Redirect } from 'react-router-dom';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAccessToken } from 'common/helpers';
import { InteractionStatus } from '@azure/msal-browser';

const TaxMaps: React.FC = () => {
  const dispatch = useDispatch();
  const {
    usState,
    loading,
    driversData,
    result,
    countyHob,
    cityHob,
    formValues,
  } = useSelector((state: AppState) => ({
    usState: usStateSelector(state),
    driversData: driversSelector(state),
    loading: loadingSelector(ReducerNames.TAX_MAPS)(state),
    result: resultSelector(state),
    countyHob: valueSelector(state, LocationFormNames.COUNTY),
    cityHob: valueSelector(state, LocationFormNames.CITY),
    formValues: getFormValues(TAX_MAPS_FORM)(state),
  }));

  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None && !usState) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getStateAction(USStateCodes.NY, response.accessToken));
      });
    }
  }, [dispatch, instance, account, inProgress, usState]);

  const login = useSelector((state: AppState) => state.login);

  const handleSubmit = () => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(
            searchTaxMaps(driversData, formValues, response.accessToken),
          );
      });
    }
  };

  if (login.user?.licenseflag == 'False') {
    return <Redirect to={`/pages/license`} />;
  }

  return (
    <Spin spinning={loading && !usState} size={Sizes.LARGE} tip={LOADING}>
      <TaxMapsForm
        {...{
          usState,
          handleSubmit,
          loading,
          driversData,
          countyHob,
          cityHob,
          formValues,
        }}
      />
      {result && <TaxMapResultTable data={result} />}
    </Spin>
  );
};

export default TaxMaps;
